import { css } from 'styled-components';
import token from 'styled-token';
import { StyledProgressBar } from '../../components/ProgressBar/ProgressBar.styles';
import { StyledProgressStepperCurrentLabel } from '../../components/ProgressStepperCurrentLabel/ProgressStepperCurrentLabel.styles';
import { StyledProgressStepperStep } from '../../components/ProgressStepperStep/ProgressStepperStep.styles';
import { StyledProgressStepperStepLabel } from '../../components/ProgressStepperStepLabel/ProgressStepperStepLabel.styles';
import { StyledProgressStepperStepLabelText } from '../../components/ProgressStepperStepLabelText/ProgressStepperStepLabelText.styles';
import { ORIENTATIONS, PROGRESS_STEPPER_LABEL_ALIGNMENTS, PROGRESS_STEPPER_LABEL_APPEARANCES } from '../../constants';
import { inlineMediaQueryMixin } from '../inlineMediaQueryMixin';
import { spaceMixin } from '../spaceMixin';
import { spacingMixin } from '../spacingMixin';
var calcStepWidth = function calcStepWidth(length) {
  return 1 / length * 100;
};
var currentStepLabelCSS = function currentStepLabelCSS(props) {
  var length = props.length;
  return token({
    fontWeight: 'ProgressStepper.label.fontWeight.current',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize'
  }, function (_ref) {
    var fontWeight = _ref.fontWeight,
      nonInteractiveStepSize = _ref.nonInteractiveStepSize;
    return css(["", "{padding:", " calc(", "% - ", "px) 0;", "{font-weight:", ";}}"], StyledProgressStepperCurrentLabel, spaceMixin('xs')(props), calcStepWidth(length) / 2, nonInteractiveStepSize, StyledProgressStepperStepLabelText, fontWeight);
  })(props);
};
var progressBarCSS = function progressBarCSS(props) {
  var length = props.length;
  return token({
    backgroundColor: 'ProgressStepper.backgroundColor',
    indicatorColor: 'ProgressStepper.indicatorColor',
    currentStepSize: 'ProgressStepper.currentStepSize',
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize',
    progressBarHeight: 'ProgressMeter.sizes.sm'
  }, function (_ref2) {
    var backgroundColor = _ref2.backgroundColor,
      indicatorColor = _ref2.indicatorColor,
      currentStepSize = _ref2.currentStepSize,
      nonInteractiveStepSize = _ref2.nonInteractiveStepSize,
      progressBarHeight = _ref2.progressBarHeight;
    return css(["", "{position:absolute;top:", "px;left:calc(", "% - ", "px);width:calc(", "% + ", "px);background-color:", ";&::before{background-color:", ";}}"], StyledProgressBar, (currentStepSize - progressBarHeight) / 2, calcStepWidth(length) / 2, nonInteractiveStepSize, 100 - calcStepWidth(length), nonInteractiveStepSize * 2, backgroundColor, indicatorColor);
  })(props);
};
var stepWidthCSS = function stepWidthCSS(props) {
  var length = props.length;
  return css(["", "{width:", "%;}"], StyledProgressStepperStep, calcStepWidth(length));
};
var labelAppearanceCSS = function labelAppearanceCSS(mediaProps) {
  var labelAppearance = mediaProps.labelAppearance,
    orientation = mediaProps.orientation;
  if (labelAppearance === PROGRESS_STEPPER_LABEL_APPEARANCES.NONE) {
    return css(["", "{display:none;}"], StyledProgressStepperStepLabel);
  }
  if (labelAppearance === PROGRESS_STEPPER_LABEL_APPEARANCES.CURRENT && orientation !== ORIENTATIONS.vertical) {
    return css(["", " > ", "{display:none;}", "{display:initial;}"], StyledProgressStepperStep, StyledProgressStepperStepLabel, StyledProgressStepperCurrentLabel);
  }
  return css(["", " > ", "{display:initial;}", "{display:none;}"], StyledProgressStepperStep, StyledProgressStepperStepLabel, StyledProgressStepperCurrentLabel);
};
var leftAlignCSS = function leftAlignCSS(props) {
  var alignLabels = props.alignLabels,
    length = props.length;
  if (alignLabels !== PROGRESS_STEPPER_LABEL_ALIGNMENTS.LEFT) {
    return '';
  }
  return token({
    nonInteractiveStepSize: 'ProgressStepper.nonInteractiveStepSize'
  }, function (_ref3) {
    var nonInteractiveStepSize = _ref3.nonInteractiveStepSize;
    return css(["", "{padding-left:0;&:nth-child(2){margin-left:calc(", "% - ", "px);}&:nth-child(", "){width:", "%;}}"], StyledProgressStepperStep, calcStepWidth(length) / 2, nonInteractiveStepSize, length + 1, calcStepWidth(length) / 2);
  });
};
var orientationCSS = function orientationCSS(props) {
  var labelAppearance = props.labelAppearance,
    length = props.length,
    orientation = props.orientation;
  if (orientation !== ORIENTATIONS.vertical) {
    return '';
  }
  return token({
    interactiveStepSize: 'ProgressStepper.interactiveStepSize',
    labelTextLineHeight: 'ProgressStepper.label.lineHeight',
    progressBarWidth: 'ProgressMeter.sizes.sm',
    stepPaddingX: 'ProgressStepper.stepPaddingX'
  }, function (_ref4) {
    var interactiveStepSize = _ref4.interactiveStepSize,
      labelTextLineHeight = _ref4.labelTextLineHeight,
      progressBarWidth = _ref4.progressBarWidth,
      stepPaddingX = _ref4.stepPaddingX;
    return css(["display:grid;grid-template-rows:repeat(", ",minmax(10px,1fr)) auto;", "{top:", "px;left:", "px;width:", "px;grid-row:1 / ", ";height:calc(100% + ", "px);}", "{width:auto;padding-left:", "px;&:nth-child(2){margin-left:0;}&:nth-child(", "){width:auto;}}", " > ", "{display:", ";}", "{display:none;}"], length - 1, StyledProgressBar, (labelTextLineHeight - progressBarWidth) / 2, (interactiveStepSize - progressBarWidth) / 2 + stepPaddingX, progressBarWidth, length, progressBarWidth, StyledProgressStepperStep, stepPaddingX, length + 1, StyledProgressStepperStep, StyledProgressStepperStepLabel, labelAppearance === PROGRESS_STEPPER_LABEL_APPEARANCES.NONE ? 'none' : 'initial', StyledProgressStepperCurrentLabel);
  });
};

/** @class ProgressStepperMixin */
/** @method */
export var ProgressStepperMixin = function ProgressStepperMixin(props) {
  return token({
    currentStepSize: 'ProgressStepper.currentStepSize'
  }, function (_ref5) {
    var currentStepSize = _ref5.currentStepSize;
    return css(["position:relative;display:flex;flex-wrap:wrap;min-height:", "px;", " ", " ", " ", " ", " ", " ", ""], currentStepSize, currentStepLabelCSS(props), progressBarCSS(props), stepWidthCSS(props), leftAlignCSS(props), inlineMediaQueryMixin('labelAppearance', labelAppearanceCSS)(props), inlineMediaQueryMixin('orientation', orientationCSS)(props), spacingMixin(props));
  })(props);
};